const isBlindReview = document.querySelector("[data-is-blind]");
const unknownFinishAnchor = document.getElementById("unknown-finish-anchor");
const unknownFinishContent = document.getElementById("unknown-finish");

if (unknownFinishAnchor && unknownFinishContent) {
  unknownFinishAnchor.addEventListener("click", () => {
    unknownFinishContent.classList.add("highlight");

    setTimeout(() => {
      unknownFinishContent.classList.remove("highlight");
    }, 1000);
  });
}

if (isBlindReview) {
  const overviewIcon = document.getElementById("overview-icon");
  const blindReviewIcon = document.getElementById("blind-icon");
  const revealDetailsButton = document.getElementById("reveal-details-btn");
  const revealContentButton = document.getElementById("reveal-content-btn");
  const initiallyDisplayedContent = document.querySelectorAll(".blind-initial");
  const blindSampleDetails = document.querySelectorAll(".blind-details");
  const blindTags = document.querySelectorAll(".blind-tag");
  const blindTagCommas = document.querySelectorAll(".blind-tag-comma");
  const initialSummaryContent = document.getElementById(
    "blind-summary-content"
  );
  const revealedSummaryContent = document.getElementById(
    "revealed-summary-content"
  );

  [revealDetailsButton, revealContentButton].forEach((button) => {
    button.addEventListener("click", () => {
      const isRevealed = JSON.parse(button.dataset.revealed);

      if (!isRevealed) {
        initiallyDisplayedContent.forEach((element) => {
          element.classList.add("hide");
        });

        blindSampleDetails.forEach((element) => {
          element.classList.remove("hide");
        });

        blindTags.forEach((element) => {
          element.classList.remove("hide");
        });
        
        blindTagCommas.forEach((element) => {
          element.classList.remove("hide");
        });

        initialSummaryContent.classList.add("hide");
        revealedSummaryContent.classList.remove("hide");

        // toggle post icons
        blindReviewIcon.classList.replace("fa-eye-slash", "fa-eye");
        overviewIcon.classList.replace("fa-folder", "fa-folder-open");

        revealDetailsButton.dataset.revealed = "true";
        revealContentButton.dataset.revealed = "true";

        revealDetailsButton.innerText = "Hide details";
        revealContentButton.innerText = "Hide details";
      } else {
        initiallyDisplayedContent.forEach((element) => {
          element.classList.remove("hide");
        });

        blindSampleDetails.forEach((element) => {
          element.classList.add("hide");
        });

        blindTags.forEach((element) => {
          element.classList.add("hide");
        });
        
        blindTagCommas.forEach((element) => {
          element.classList.add("hide");
        });

        initialSummaryContent.classList.remove("hide");
        revealedSummaryContent.classList.add("hide");

        // toggle post icon
        blindReviewIcon.classList.replace("fa-eye", "fa-eye-slash");
        overviewIcon.classList.replace("fa-folder-open", "fa-folder");

        revealDetailsButton.dataset.revealed = "false";
        revealContentButton.dataset.revealed = "false";

        revealDetailsButton.innerText = "Reveal details";
        revealContentButton.innerText = "Reveal details";
      }
    });
  });
}
